<div class="bg-white" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'p-4' : 'px-0 px-sm-3 m-3'">
  <div class="item-center app-auth-header-icon" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'm-3' : 'm-5'">
    <div>
      <mat-icon svgIcon="falBell" class="icon-center" [ngStyle]="UIUtilityService.getWarningIconStyle()"></mat-icon>
    </div>
  </div>

  <div class="d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
    <span
      class="font-dialog-confirm-title text-center"
      [ngClass]="{'mobile-font-dialog-confirm-title': (srvRpDesign.isMobile$ | async)}">
      {{ 'APP_AUTHENTICATOR.RESET_PASSWORD_TITLE' | translate }}
    </span>
  </div>

  <div
    class="font-dialog-confirm-content"
    mat-dialog-content
    [ngClass]="(srvRpDesign.isMobile$ | async) ? 'my-3 p-0 mobile-font-dialog-confirm-content' : 'mt-4 mx-3'">
    <p class="text-center mb-3">
      {{ 'APP_AUTHENTICATOR.NO_NOTIFICATION_MESSAGE' | translate }}
    </p>

    <button type="button" class="no-notif-option" (click)="onSendNotification()">
      <mat-icon svgIcon="falBell" class="no-notif-option-icon" [ngStyle]="UIUtilityService.getIconStyle()"></mat-icon>
      <span class="no-notif-option-text">{{ 'APP_AUTHENTICATOR.RESET_PASSWORD_SEND_NOTIFICATION' | translate }}</span>
    </button>

    <button type="button" class="no-notif-option" (click)="onSendCode()">
      <mat-icon svgIcon="farCommentsAlt" class="no-notif-option-icon" [ngStyle]="UIUtilityService.getIconStyle()"></mat-icon>
      <span class="no-notif-option-text">{{ 'APP_AUTHENTICATOR.NO_NOTIFICATION_SEND_CODE' | translate }}</span>
    </button>
  </div>

  <div
    class="d-flex justify-content-center"
    mat-dialog-actions
    [ngClass]="(srvRpDesign.isMobile$ | async) ? 'mt-2' : 'my-3'">
    <button
      class="font-button button-action-cancel"
      [ngClass]="(srvRpDesign.isMobile$ | async) ? 'p-4' : 'btn-lg py-4 px-4 px-sm-5'"
      mat-button
      (click)="onCancel()">
      {{ 'BUTTON_CANCEL' | translate }}
    </button>
  </div>
</div>
